import { Link, Outlet, useHref } from 'react-router-dom';
import { Bug, Lightbulb, ListTodo } from 'lucide-react';
import { IDEA_STATUS } from './_enums';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { useZealBugReports, useZealTasks } from '@/data/zealTask';

const Count = ({ value }) => {
  if (value === undefined) return null;
  return <span className="rounded-full bg-muted-foreground/15 px-1.5 py-0.5 text-xs font-medium tabular-nums leading-none">{value}</span>;
};

const TasksPage = () => {
  const pathname = useHref();
  const tasks = useZealTasks();
  const reports = useZealBugReports();

  const taskCount = tasks.data?.query.length;
  const ideaCount = tasks.data && tasks.data.query.filter((id) => tasks.data.content[id].status === IDEA_STATUS).length;
  const bugCount = reports.data?.query.length;

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Tasks</h1>
        <p className="text-sm text-muted-foreground">What the dev team is working on in Zeal. File a feature idea or report a bug, and follow it from here.</p>
      </div>

      <Tabs value={pathname} className="w-full">
        <TabsList className="w-full">
          <TabsTrigger value="/tasks" className="flex-1" asChild>
            <Link to="/tasks">
              <ListTodo />
              All tasks
              <Count value={taskCount} />
            </Link>
          </TabsTrigger>
          <TabsTrigger value="/tasks/ideas" className="flex-1" asChild>
            <Link to="/tasks/ideas">
              <Lightbulb />
              Feature ideas
              <Count value={ideaCount} />
            </Link>
          </TabsTrigger>
          <TabsTrigger value="/tasks/bugs" className="flex-1" asChild>
            <Link to="/tasks/bugs">
              <Bug />
              Bugs
              <Count value={bugCount} />
            </Link>
          </TabsTrigger>
        </TabsList>
      </Tabs>

      <Outlet />
    </div>
  );
};

export default TasksPage;
